import { LowWithLodash } from '@ow/lowdb'

export default class LowDittoDB {
  constructor(Adaptor, options) {
    this.db = new LowWithLodash(Adaptor)
    this.db.data = {
      opts: options,
      docs: {},
    }
  }

  findById() {
    this.db.chain.get('docs').find()
  }

  all() {
    return Promise.resolve(this.db.data.docs)
  }

  findByIds(ids) {
    return Promise.resolve(Object.values(this.db.chain.get('docs').pick(ids).value()))
  }

  saveMeta(meta) {
    this.db.data.meta = meta
    return Promise.resolve(this)
  }

  save(doc) {
    this.db.data.docs[doc._id] = doc
    return this.saveMeta()
  }

  bulkSave(docs) {
    docs.forEach((doc) => {
      this.db.data.docs[doc._id] = doc
    })
    return this.saveMeta()
  }
}
